import '../../common_screen/my_teams_list/index_web.css';
import FlatList from 'flatlist-react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'underscore';
import { showToast } from '../../../actions/app-actions-types';
import {
  ErrorMessage,
  FlatListWrapper,
  PlaceHolder,
  ScreenBackground,
  View
} from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import { getRouteObjByGame } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import { NoContestJoined, TeamBox } from '../../component';
import { useLink } from 'react-router-stack';
import PullToRefresh from 'react-simple-pull-to-refresh';
import Button from '@mui/material/Button/Button';

const MyTeamsList = () => {
  const { FantasyTheme: theme } = useTheme();
  const navigate = useLink();
  const {
    userId,
    item: matchItem,
    getMyMatchTeamList,
    fantasyMatchClick,
    getPlayerList,
    gameType,
    myTeamList: myTeamList_ = []
  } = useGame();

  const {
    _id: matchId,
    contestId,
    entryFee,
    bonusPercentage = 0,
    isTeamSwitch = false,
    competition = {},
    contestTeams = [],
    tabType = ''
  } = matchItem;

  const { title = '' } = competition;
  const [myTeamList, setMyTeamList] = useState([] as any);
  const dispatch = useDispatch();
  const [resultArrivedTeamList, setResultArrivedTeamList] = useState(false);
  const [resultArrivedPlayerList, setResultArrivedPlayerList] = useState(false);
  const [matchAllPlayersList, setMatchAllPlayerList] = useState([]);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);
  const totalTeamsCount = myTeamList.length;

  useEffect(() => {
    getMyTeamList({});
    getAllPlayerListAPI();
    EventEmitter.on('teamUpdate', getMyTeamList);
    return () => {
      EventEmitter.off('teamUpdate', getMyTeamList);
    };
  }, []);

  useEffect(() => {
    if (myTeamList_.length != myTeamList.length) {
      myTeamList_.sort((a: { teamNumber: number }, b: { teamNumber: number }) =>
        a.teamNumber > b.teamNumber ? 1 : -1
      );
      setMyTeamList(myTeamList_);
    }
  }, [myTeamList_.length]);

  const getAllPlayerListAPI = () => {
    const data = {
      matchId
    };
    dispatch(
      getPlayerList({
        data,
        callback: ({ result = [], error }: { result: any; error: any }) => {
          if (!error && result) {
            setResultArrivedPlayerList(true);
            setMatchAllPlayerList(result);
            ///this is for calculate line up out
            let playingPlayersList = [];
            playingPlayersList = result.filter(
              (player: { playingEleven: boolean }) => player.playingEleven === true
            );
            setLineupsOut(playingPlayersList.length >= 15);
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const getMyTeamList = async ({ latestTeamData = { id: '' } } = {}) => {
    const data = {
      matchId,
      userId
    };
    await dispatch(
      getMyMatchTeamList({
        data,
        callback: ({ result = [], error }: { result: any; error: any }) => {
          if (!error && result) {
            const { id = '' } = latestTeamData;
            let isNotExistLatestTeam = _.findWhere(result, { id });
            if (id && !isNotExistLatestTeam) {
              result.push(latestTeamData);
            }
            result.sort((a: { teamNumber: number }, b: { teamNumber: number }) =>
              a.teamNumber > b.teamNumber ? 1 : -1
            );
            setMyTeamList(result);
            setResultArrivedTeamList(true);
            setError(false);
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const onRefresh = async () => {
    await getMyTeamList({});
  };

  const onPressPreview = (teamData: any, teamNumber: any) => {
    navigate.push(getRouteObjByGame(gameType)['team_preview'], {
      teamData,
      matchId,
      teamNumber,
      item: matchItem,
      fromCreateTeam: false,
      lineupsOut,
      matchAllPlayersList,
      gameType,
      isMyUser: true
    });
  };

  const onPressConvertSubstituteMode = (teamData: any, teamNumber: any) => {
    navigate.push(getRouteObjByGame(gameType)['team_preview'], {
      teamData: teamData,
      matchId,
      teamNumber,
      item: matchItem,
      fromCreateTeam: false,
      lineupsOut,
      matchAllPlayersList,
      isMyUser: true
    });
  };

  const onPressClone = (teamData: any, teamNumber: any) => {
    const { players = [] } = teamData;
    let playerList: any[] = [];
    const substitutePlayerList = players.filter((x: any) => x.substitutePlayerId);
    players.forEach((item: any) => {
      let substituteObj = _.findWhere(substitutePlayerList, {
        substitutePlayerId: item.playerId
      });
      if (!substituteObj) {
        playerList.push({
          id: item.id,
          playerId: item.playerId,
          state: 0
        });
      }
    });

    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            selectedTeamPlayers: playerList,
            isEdit: false,
            teamNumber,
            isClone: true,
            joinedMatch: false,
            entryFee,
            contestId,
            teamData: {
              ...teamData,
              teamNumber: totalTeamsCount + 1
            },
            bonusPercentage,
            isTeamSwitch,
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const onPressEdit = (teamData: any, teamNumber: any) => {
    const { players = [], substitutedCaptainId = '', substitutedViceCaptainId = '' } = teamData;
    let playerList: any[] = [];
    const substitutionPlayerList = players.filter((x: any) => x.substitutePlayerId);
    const substitutePlayerList: any[] = [];
    const substitutePlayers = {} as any;
    players.forEach((item: any) => {
      let substituteObj = _.findWhere(substitutionPlayerList, {
        substitutePlayerId: item.playerId
      });
      if (!substituteObj) {
        playerList.push({
          id: item.id,
          playerId: item.playerId,
          state: 0,
          substitutePlayerId: item.substitutePlayerId
        });
      } else {
        substitutePlayerList.push({
          id: item.id,
          playerId: item.playerId,
          state: 0
        });
        substitutePlayers[item.playerId] = 1;
      }
    });

    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          selectedTeamPlayers: playerList,
          isEdit: true,
          teamNumber,
          joinedMatch: false,
          isClone: false,
          entryFee,
          contestId,
          teamData,
          bonusPercentage,
          isTeamSwitch,
          substitutePlayerList,
          substitutePlayers,
          substitutedCaptainId,
          substitutedViceCaptainId
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['create_team']);
  };

  const renderItem = (item: any) => {
    return (
      <TeamBox
        selectTeamByUser={() => {}}
        joinedMatch={false}
        item={item}
        key={item.matchTeamId}
        onPressPreview={onPressPreview}
        onPressClone={onPressClone}
        onPressEdit={onPressEdit}
        onPressAlreadyJoin={() => {}}
        lineupsOut={lineupsOut}
        title={title}
        matchAllPlayersList={matchAllPlayersList}
        contestTeams={contestTeams}
        gameType={gameType}
        tabType={tabType}
        onPressConvertSubstituteMode={onPressConvertSubstituteMode}
      />
    );
  };

  const onPressRetry = () => {
    setResultArrivedTeamList(false);
    getMyTeamList({});
  };

  const onPressAddTeam = () => {
    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            isEdit: false,
            isClone: false,
            joinedMatch: false,
            entryFee,
            contestId,
            isTeamSwitch,
            selectedTeamPlayers: [],
            teamData: {
              teamNumber: totalTeamsCount + 1
            },
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const renderWhenEmpty = () => {
    if (!resultArrivedTeamList || !resultArrivedPlayerList)
      return <PlaceHolder.Loader loadingMessage={''} />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return (
      <NoContestJoined
        message={I18n.t('NoTeam')}
        buttonLabel={I18n.t('CreateYourTeam')}
        onPress={onPressAddTeam}
      />
    );
  };

  const addTeamBtnColor: any = {
    backgroundColor: theme.myTeamAddTeamBtn,
    shadowColor: theme.myTeamAddTeamBtn,
    color: '#fff',
    fontFamily: 'ProximaNova-Bold',
    width: '150px',
    textTransform: 'none'
  };

  // const disableBtnText = {
  //   color: theme.myTeamJoinContestDisableBtnText
  // };

  return (
    <ScreenBackground>
      <View className="my-team-list-container">
        <PullToRefresh onRefresh={onRefresh}>
          <FlatListWrapper
            style={{
              paddingBottom: '180px'
            }}>
            <FlatList
              list={myTeamList}
              renderItem={renderItem}
              renderOnScroll
              renderWhenEmpty={renderWhenEmpty}
            />
          </FlatListWrapper>
        </PullToRefresh>

        {totalTeamsCount < 11 && myTeamList.length !== 0 && (
          <View className={'my-team-list-create-button-container'}>
            <Button
              className={'my-team-list-create-button-'}
              onClick={onPressAddTeam}
              style={addTeamBtnColor}>
              {I18n.t('createTeam')}
            </Button>
          </View>
        )}
      </View>
    </ScreenBackground>
  );
};

export default MyTeamsList;
